import { createApp } from "vue";
import { i18n } from "i18n";
import vui from "vui";
import LoginDialog from "Dialog";
import LoginPage from "Page";

const dialogEl = document.getElementById("login-dialog");

const dialogApp = createApp(LoginDialog, {
	authEmail: dialogEl.dataset.authEmail,
	loginEmail: dialogEl.dataset.loginEmail
});

dialogApp.use(i18n);
dialogApp.use(vui);

dialogApp.mount(dialogEl);

const loginEl = document.getElementById("login");

if (loginEl) {
	const app = createApp(LoginPage, { target: loginEl.dataset.target });

	app.use(i18n);
	app.use(vui);

	app.mount(loginEl);
}
